const truncateTransitionDurationMs = 225;
const truncateWrapper = "dibthw7m4l";
const transition = "dibt1qk7f2c";
const expandButton = "dibeittjrw";

export { expandButton, transition, truncateTransitionDurationMs, truncateWrapper };
import "./_input-toggle-group.style.linaria.module.css";
//# sourceMappingURL=_input-toggle-group.style.js.map
